import React, { Fragment } from 'react'

import { Col, Grid, Space } from '@gousto-internal/citrus-react'
import PropTypes from 'prop-types'

import { Divider } from '../components/Divider'
import { Section } from '../components/Section'
import {
  yourSubscriptionDetailsSection,
  defaultRecipeSettingsSection,
  skipABoxSection,
  pauseSubscriptionSection,
} from '../subscriptionsSectionsContent'
import { DietaryPreference } from './sections/DefaultRecipeSettings/DietaryPreference'
import { InfoPanel } from './sections/DefaultRecipeSettings/InfoPanel/InfoPanel'
import { RecipesPerBox } from './sections/DefaultRecipeSettings/RecipesPerBox'
import { PauseSubscription } from './sections/PauseSubscription'
import { SkipABox } from './sections/SkipABox'
import { BoxSize } from './sections/YourSubscriptionDetails/BoxSize'
import { DeliveryDayAndTime } from './sections/YourSubscriptionDetails/DeliveryDayAndTime'
import { Frequency } from './sections/YourSubscriptionDetails/Frequency'

const ActiveSubscription = ({ accessToken, isMobile, handlePause }) => (
  <Fragment>
    <Grid columnGap={[0, 6]} paddingH={[0, 3]}>
      <Col size={[12, 6]}>
        <Section
          title={yourSubscriptionDetailsSection.title}
          subTitle={yourSubscriptionDetailsSection.subTitle}
          testingSelector={yourSubscriptionDetailsSection.testingSelector}
        >
          <DeliveryDayAndTime accessToken={accessToken} isMobile={isMobile} />
          <BoxSize accessToken={accessToken} isMobile={isMobile} />
          <Frequency accessToken={accessToken} isMobile={isMobile} />
        </Section>
      </Col>
      <Col size={[12, 6]}>
        <Section
          title={defaultRecipeSettingsSection.title}
          testingSelector={defaultRecipeSettingsSection.testingSelector}
        >
          <InfoPanel />
          <Space direction="horizontal" size={2} />
          <RecipesPerBox accessToken={accessToken} isMobile={isMobile} />
          <DietaryPreference accessToken={accessToken} isMobile={isMobile} />
        </Section>
      </Col>
    </Grid>

    <Grid paddingH={[2, 3]}>
      <Col size={12}>
        <Divider hidden={['sm']} />
      </Col>
    </Grid>

    <Grid columnGap={[0, 6]} paddingH={[0, 3]}>
      <Col size={[12, 6]}>
        <Section
          title={skipABoxSection.title}
          subTitle={skipABoxSection.subTitle}
          testingSelector={skipABoxSection.testingSelector}
        >
          <SkipABox />
        </Section>
      </Col>
      <Col size={[12, 6]}>
        <Section
          title={pauseSubscriptionSection.title}
          subTitle={pauseSubscriptionSection.subTitle}
          testingSelector={pauseSubscriptionSection.testingSelector}
        >
          <PauseSubscription handlePause={handlePause} />
        </Section>
      </Col>
    </Grid>
  </Fragment>
)

ActiveSubscription.propTypes = {
  accessToken: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired,
  handlePause: PropTypes.func.isRequired,
}

export { ActiveSubscription }
